export default __webpack_public_path__ + "static/media/10.b5d6ff47.jpg";